export const EPG_SIDEBAR_SKELETON_SIZES = {
  CHANNEL_TITLE_SKELETON_HEIGHT: '--channel-title-skeleton-height',
  CHANNEL_TITLE_SKELETON_WIDTH: '--channel-title-skeleton-width',

  LABEL_GROUP_SKELETON_HEIGHT: '--label-group-skeleton-height',
  LABEL_GROUP_SKELETON_WIDTH: '--label-group-skeleton-width',

  PROGRAM_TITLE_SKELETON_HEIGHT: '--program-title-skeleton-height',
  PROGRAM_TITLE_SKELETON_WIDTH: '--program-title-skeleton-width',

  PROGRAM_DESCRIPTION_SKELETON_HEIGHT: '--program-description-skeleton-height',
  PROGRAM_DESCRIPTION_SKELETON_WIDTH: '--program-description-skeleton-width',
} as const
export type EPG_SIDEBAR_SKELETON_SIZES =
  (typeof EPG_SIDEBAR_SKELETON_SIZES)[keyof typeof EPG_SIDEBAR_SKELETON_SIZES]
